import { render } from "./FormularioProspeccao.vue?vue&type=template&id=71351e71&scoped=true"
import script from "./FormularioProspeccao.vue?vue&type=script&lang=js"
export * from "./FormularioProspeccao.vue?vue&type=script&lang=js"

import "./FormularioProspeccao.vue?vue&type=style&index=0&id=71351e71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71351e71"]])

export default __exports__